import { Fragment, useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ResolveDialog } from "@/components/admin/ResolveDialog";
import { UnmatchedSuggestions } from "@/components/admin/UnmatchedSuggestions";
import { errMsg, useApi } from "@/lib/api";
import { rm, tarikh } from "@/pages/AkaunPage";

const STATUS = [["baru", "Belum diproses"], ["selesai", "Selesai"], ["diabaikan", "Diabaikan"], ["", "Semua"]];

export const UnmatchedPayments = () => {
  const api = useApi();
  const [status, setStatus] = useState("baru");
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(null);
  const load = useCallback(() => api("get", "/admin/billing/unmatched", null, { params: { status } }).then((r) => { setItems(r); window.dispatchEvent(new Event("unmatched-changed")); }).catch(() => setItems([])), [api, status]);
  useEffect(() => { load(); }, [load]);
  const ignore = async (id) => {
    try { await api("post", `/admin/billing/unmatched/${id}/ignore`); toast.success("Diabaikan"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4" data-testid="admin-unmatched">
      <p className="text-sm text-mute max-w-2xl">Notifikasi OnPay yang tidak dapat dipadankan secara automatik (contohnya pelanggan guna emel berbeza). Pilih pengguna untuk aktifkan kuota secara manual.</p>
      <div className="flex gap-2 flex-wrap">
        {STATUS.map(([v, l]) => (
          <button key={v || "all"} onClick={() => setStatus(v)} data-testid={`unmatched-filter-${v || "all"}`}
            className={`h-8 px-3 rounded-full text-xs border border-line transition-colors ${status === v ? "bg-ink text-bg" : "hover:bg-surface"}`}>{l}</button>
        ))}
      </div>
      {!items ? <Loader2 className="animate-spin text-q" /> : (
        <div className="rounded-xl border border-line overflow-x-auto surface">
          <Table>
            <TableHeader><TableRow><TableHead>Tarikh</TableHead><TableHead>Emel OnPay</TableHead><TableHead className="text-right">Jumlah</TableHead><TableHead>Aktiviti</TableHead><TableHead>Invois</TableHead><TableHead>Status</TableHead><TableHead /></TableRow></TableHeader>
            <TableBody>
              {items.map((u) => (
                <Fragment key={u.id}>
                <TableRow data-testid={`unmatched-row-${u.id}`} className={u.status === "baru" ? "border-b-0" : ""}>
                  <TableCell className="text-xs font-mono-data">{tarikh(u.created_at)}</TableCell>
                  <TableCell className="text-sm">{u.email || "—"}</TableCell>
                  <TableCell className="text-right font-mono-data">{u.amount_sen != null ? rm(u.amount_sen) : "—"}</TableCell>
                  <TableCell className="text-xs">{u.event || "—"}</TableCell>
                  <TableCell className="text-xs font-mono-data">{u.invois || "—"}</TableCell>
                  <TableCell className="text-xs">{u.status}{u.resolved_by && <div className="text-mute">{u.resolved_by}</div>}</TableCell>
                  <TableCell className="whitespace-nowrap">
                    {u.status === "baru" && (<>
                      <button onClick={() => setSel(u)} className="text-sm text-q underline underline-offset-4 mr-3" data-testid={`unmatched-resolve-${u.id}`}>Aktifkan</button>
                      <button onClick={() => ignore(u.id)} className="text-sm text-mute hover:text-warn" data-testid={`unmatched-ignore-${u.id}`}>Abaikan</button>
                    </>)}
                  </TableCell>
                </TableRow>
                {u.status === "baru" && (
                  <TableRow className="hover:bg-transparent"><TableCell colSpan={7} className="pt-0 pb-3"><UnmatchedSuggestions item={u} onDone={load} /></TableCell></TableRow>
                )}
                </Fragment>
              ))}
            </TableBody>
          </Table>
          {items.length === 0 && <p className="p-4 text-sm text-mute" data-testid="unmatched-empty">Tiada rekod.</p>}
        </div>
      )}
      {sel && <ResolveDialog item={sel} onClose={() => setSel(null)} onDone={() => { setSel(null); load(); }} />}
    </div>
  );
};
